// removed by extract-text-webpack-plugin
module.exports = {"CollectionLink":"Collection__CollectionLink__3dtrz","Title":"Collection__Title__qX17e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Collection/Collection.css
// module id = 207
// module chunks = 0